import { apiClient } from '@/utils/api-client';

export interface Organization {
  id: number;
  name: string;
  registrating_slug?: string;
  active?: boolean;
}

interface ListOrganizationsParams {
  has_products?: boolean;
  active_licenses_only?: boolean;
  q?: string;
}

export const organizationService = {
  async listOrganizations(params?: ListOrganizationsParams): Promise<{ data: { id: string; attributes: Organization }[] }> {
    return apiClient.get('/api/admin/accounts', params);
  },

  async getOrganization(id: string): Promise<{ data: { id: string; attributes: Organization } }> {
    return apiClient.get(`/api/admin/accounts/${id}`);
  },
};